import { render } from "./landing_page.vue?vue&type=template&id=31016a93&scoped=true"
import script from "./landing_page.vue?vue&type=script&lang=js"
export * from "./landing_page.vue?vue&type=script&lang=js"

import "./landing_page.vue?vue&type=style&index=0&id=31016a93&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31016a93"]])

export default __exports__